
(function(){
  const init=()=>{
    document.querySelectorAll('[data-slider]').forEach(s=>{
      const t=s.querySelector('.product-track');
      s.querySelector('.next')?.addEventListener('click',()=>t.scrollBy({left:t.clientWidth*.82,behavior:'smooth'}));
      s.querySelector('.prev')?.addEventListener('click',()=>t.scrollBy({left:-t.clientWidth*.82,behavior:'smooth'}));
    });
    document.querySelectorAll('.lab-tabs').forEach(t=>{
      const tabs=t.querySelectorAll('[data-tab]'), root=t.closest('.lab-grid');
      tabs.forEach(b=>b.addEventListener('click',()=>{
        tabs.forEach(x=>x.classList.remove('active')); b.classList.add('active');
        root.querySelectorAll('[data-panel]').forEach(p=>p.classList.toggle('active',p.dataset.panel===b.dataset.tab));
      }));
    });
    document.querySelectorAll('.result-wrap').forEach(r=>{
      const input=r.querySelector('.result-range'), before=r.querySelector('.result-before'), line=r.querySelector('.drag-line');
      const update=()=>{const v=Math.max(0,Math.min(100,Number(input.value)||50)); before.style.width=v+'%'; line.style.left=v+'%';};
      input.addEventListener('input',update); update();
    });
  };
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',init);else init();
})();

(function(){
  const initFinder=()=>{
    document.querySelectorAll('[data-finder]').forEach(root=>{
      const tabs=root.querySelectorAll('[data-finder-tab]');
      const panels=root.querySelectorAll('[data-finder-panel]');
      tabs.forEach(tab=>tab.addEventListener('click',()=>{
        const id=tab.dataset.finderTab;
        tabs.forEach(x=>x.classList.toggle('active',x===tab));
        panels.forEach(x=>x.classList.toggle('active',x.dataset.finderPanel===id));
      }));
    });
  };
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',initFinder);else initFinder();
})();

document.addEventListener('DOMContentLoaded',function(){
  const btn=document.querySelector('.aish-menu-btn');
  const nav=document.querySelector('.aish-mobile-nav');
  if(btn&&nav){btn.addEventListener('click',function(){const open=nav.classList.toggle('is-open');btn.setAttribute('aria-expanded',open?'true':'false');nav.setAttribute('aria-hidden',open?'false':'true');});nav.querySelectorAll('a').forEach(a=>a.addEventListener('click',()=>{nav.classList.remove('is-open');btn.setAttribute('aria-expanded','false');nav.setAttribute('aria-hidden','true');}));}
});


(function(){
  const initCarousels=()=>{
    document.querySelectorAll('[data-carousel]').forEach(root=>{
      const track=root.querySelector('.aish-carousel-track');
      const next=root.querySelector('.carousel-btn.next');
      const prev=root.querySelector('.carousel-btn.prev');
      if(!track) return;
      const amount=()=>Math.max(track.clientWidth*.72, track.clientWidth*.32);
      next?.addEventListener('click',()=>track.scrollBy({left:amount(),behavior:'smooth'}));
      prev?.addEventListener('click',()=>track.scrollBy({left:-amount(),behavior:'smooth'}));
    });
  };
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',initCarousels);else initCarousels();
})();
